export enum ERRORS {
  UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  USER_UNAUTHORIZED = 'Unauthorized',
}
